/**
 * Created by forbiz on 2019-02-11.
 */

import common from './divide/common';
import layout from './divide/layout';
import reg from './divide/reg.js';
import main from './divide/main';
import displayList from './divide/displayList';
import bestList from './divide/bestList';
import market from './divide/market';
import greatingLifeDetail from './divide/greatingLifeDetail';
import marketList from './divide/marketList';
import marketDetail from './divide/marketDetail';
import eventList from './divide/eventList';
import eventDetail from './divide/eventDetail';
import orderCart from './divide/orderCart';
import myOrderList from './divide/myOrderList';
import orderPayment from './divide/orderPayment';
import caulseAgree from './divide/caulseAgree';
import myPersonalInquery from './divide/myPersonalInquery';
import myPage from './divide/myPage';
import applyOrderExchange from './divide/applyOrderExchange';
import myShippingAddrDetail from './divide/myShippingAddrDetail';
import monthStoryList from './divide/monthStoryList';
import story from './divide/story';
import brandStory from './divide/brandStory';
import meals from './divide/meals';

window.$ = window.jquery = window.jQuery = require('jquery');

const appMethods = {
    layout,
    main,
    displayList,
    bestList,
    market,
    greatingLifeDetail,
    marketList,
    marketDetail,
    eventList,
    eventDetail,
    orderCart,
    myOrderList,
    orderPayment,
    caulseAgree,
    myPersonalInquery,
    myPage,
    applyOrderExchange,
    myShippingAddrDetail,
    monthStoryList,
    story,
    brandStory,
    meals
};


const appInit = () => {
    const appName = $('body').attr('id');
    if(appName) [common, layout, reg, appMethods[appName]].forEach(method  => {
        if(method) method();

    });
};

document.addEventListener('DOMContentLoaded', () => {
    appInit();
});